import {useCallback, useRef, useState} from 'react';

const SUFFIX_CONSTANTS = {
  INPUT_PADDING_LEFT: 12,
  SUFFIX_SPACING: 8,
  SUFFIX_FINE_TUNE: 2,
  SUFFIX_BOTTOM_POSITION: 13,
  HIDDEN_POSITION: -1000
};

export {SUFFIX_CONSTANTS};

export function useSuffixPosition(suffix) {
  const [suffixLeft, setSuffixLeft] = useState(0);
  const hiddenSpanRef = useRef(null);

  const updateSuffixPosition = useCallback(
    (inputValue) => {
      const inputStr = String(inputValue);

      if (
        !suffix ||
        !hiddenSpanRef.current ||
        inputValue === null ||
        inputValue === undefined ||
        inputStr === ''
      ) {
        setSuffixLeft(SUFFIX_CONSTANTS.HIDDEN_POSITION);
        return;
      }

      hiddenSpanRef.current.textContent = inputStr;

      void hiddenSpanRef.current.offsetHeight;
      const textWidth = hiddenSpanRef.current.offsetWidth;

      const calculatedLeft =
        Math.max(textWidth, 1) + SUFFIX_CONSTANTS.SUFFIX_SPACING;
      setSuffixLeft(calculatedLeft);
    },
    [suffix]
  );

  const shouldRenderSuffix = useCallback(
    (value) => {
      return (
        value !== null &&
        value !== undefined &&
        String(value) !== '' &&
        suffixLeft > 0
      );
    },
    [suffixLeft]
  );

  return {suffixLeft, hiddenSpanRef, updateSuffixPosition, shouldRenderSuffix};
}
